var N = /* @__PURE__ */ ((r) => (r[r.NONE = 0] = "NONE", r[r.RUNNING = 1] = "RUNNING", r[r.FAILED = 2] = "FAILED", r[r.COMPLETED = 3] = "COMPLETED", r))(N || {});
class u {
  status;
  value;
  error;
  progress;
  constructor(n, i, t, h) {
    this.status = n || 0, this.value = i || null, this.error = t || null, this.progress = h || null;
  }
  resolving() {
    return this.status != 0;
  }
  completeWith(n, i = null) {
    return new u(
      3,
      n,
      this.error,
      i
    );
  }
  failWith(n, i = null) {
    return new u(
      2,
      this.value,
      n,
      i
    );
  }
  updateRunning(n = null) {
    return new u(
      1,
      this.value,
      this.error,
      n
    );
  }
}
export {
  u as Resolvable,
  N as ResolvableStatus
};
